/**
 * Das Urteil "stark im Raid" vs. "nur für die Sammlung" ist die zentrale
 * Aussage der Pokémon-Seiten. Damit Übersicht und Detailseite dieselbe
 * Sprache und dieselben Farben verwenden, steht es hier an einer Stelle.
 */

export const VERDICT = {
  strong: {
    label: 'Stark im Raid',
    kurz: 'Stark',
    farbe: 'var(--verdict-strong)',
    erklaerung: 'Gehört zu den besten Angreifern seines Typs.',
  },
  solid: {
    label: 'Solide Ergänzung',
    kurz: 'Solide',
    farbe: 'var(--verdict-solid)',
    erklaerung: 'Brauchbar, aber nicht an der Spitze.',
  },
  collection: {
    label: 'Für die Sammlung',
    kurz: 'Sammlung',
    farbe: 'var(--verdict-collection)',
    erklaerung: 'Im Raid ohne Bedeutung — für Dex und Shiny.',
  },
  unrated: {
    label: 'Noch nicht bewertet',
    kurz: 'Offen',
    farbe: 'var(--verdict-unrated)',
    erklaerung: 'Keine Einstufung vorhanden.',
  },
};

export function VerdictBadge({ verdict, tier }) {
  const v = VERDICT[verdict] ?? VERDICT.unrated;

  return (
    <span className="badge" style={{ '--badge-color': v.farbe }}>
      {v.label}
      {tier && <span className={`tier tier--${tier} tier--inline`}>{tier}</span>}
    </span>
  );
}
